<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'挥剑问情'"></div>
    <div>挥剑问情 帮助页</div>
  </div>

</template>
<script>
export default {
  name: 'demo',
  components: {},
  data () {
    return {};
  },
  created () {},
  mounted () {},
  computed: {},
  methods: {}
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/kfhd/help/index.vue